// src/components/ErrorBoundary.js
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ error, errorInfo });
    // Log l'erreur à un service externe si nécessaire
    console.error(error, errorInfo);
  }

  render() {
    if (this.state.error) {
      return (
        <div>
          <h2>Une erreur s'est produite.</h2>
          <p>{this.state.error.toString()}</p>
          <details>
            {this.state.errorInfo?.componentStack || "Aucun détail disponible"}
          </details>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;